<div>
  <app-button
    (click)="openModal(modalSettingColumn)"
    (mouseenter)="onMouseEnter(iconPayment)"
    (mouseleave)="onMouseLeave(iconPayment)"
    #iconPayment
    [style]="{ width: 'auto', borderRadius: '8px' }"
    [class]="'btn btn-outline-primary btn-icon-text'"
    [text]="'tools.postback.column' | translate"
    [icon]="'mdi mdi-cog-outline'"
    [iconColor]="'#308DE3'"
  ></app-button>
</div>

<ng-template #modalSettingColumn let-modal>
  <div class="modal-header">
    <button
      type="button"
      class="btn-close"
      (click)="modal.close('by: close icon')"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body">
    <div class="title-modal">{{ "table.add_column" | translate }}</div>

    <div class="group-checkbox" style="margin-top: 24px">
      <div class="row">
        <ng-container *ngFor="let columns of listColumnsCurrent; let i = index">
          <div
            [class]="isTabView ? 'col-md-12' : 'col-md-4'"
            style="margin-top: 8px"
          >
            <div
              [style]="isMobile ? 'margin-top: 24px' : ''"
              class="title-group"
            >
              {{ "table.parent_column." + columns.key | translate }}
            </div>
            <ng-container *ngFor="let item of columns['items']; let j = index">
              <div>
                <input
                  (click)="changesSelectedTableParameters(i, j)"
                  type="checkbox"
                  class="form-check-input"
                  id="{{ item.key }}"
                  [checked]="item.default === 1"
                />
                <label class="title-checkbox" for="{{ item.key }}">
                  {{ "table.list_columns." + item.key | translate }}
                </label>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>

    <div
      class="d-flex"
      [style]="
        isMobile
          ? 'margin-top: 24px; justify-content: center; width: 100%; gap:20px'
          : 'margin-top: 24px; justify-content: center'
      "
    >
      <div [style]="isMobile ? 'width: 100%' : 'margin-right: 12px'">
        <app-button
          (click)="modal.close('by: close button')"
          [style]="{ width: isMobile ? '100%' : '160px', borderRadius: '8px' }"
          [class]="'btn btn-outline-primary'"
          [text]="'offers.detail.close' | translate"
        ></app-button>
      </div>

      <div [style]="isMobile ? 'width: 100%' : 'margin-left: 12px'">
        <app-button
          (click)="save()"
          [style]="{ width: isMobile ? '100%' : '160px', borderRadius: '8px' }"
          [class]="'btn btn-primary'"
          [text]="'offers.detail.save' | translate"
        ></app-button>
      </div>
    </div>
  </div>
</ng-template>
